import React from 'react'
import { mdiAlert } from '@mdi/js'

import { ClaimDeviceH4 } from '../styles'
import {
  ClaimDeviceErrorContainer,
  ClaimDeviceErrorDescription,
  ClaimDeviceErrorIcon,
  ClaimDeviceErrorRetryButton,
  ClaimDeviceErrorSpan,
} from './styles'

interface AlreadyClaimedErrorProps {
  onEraseDataClick: () => void
}

// TODO: Localize
function BadDeviceDataError({ onEraseDataClick }: AlreadyClaimedErrorProps) {
  return (
    <ClaimDeviceErrorContainer>
      <ClaimDeviceErrorIcon path={mdiAlert} size={2} />
      <ClaimDeviceH4>Wrong Device Code</ClaimDeviceH4>
      <ClaimDeviceErrorDescription>
        <ClaimDeviceErrorSpan>
          Please claim another device.
        </ClaimDeviceErrorSpan>
      </ClaimDeviceErrorDescription>
      <ClaimDeviceErrorRetryButton
        variant="primary"
        type="button"
        onClick={onEraseDataClick}
      >
        Claim Another Device
      </ClaimDeviceErrorRetryButton>
    </ClaimDeviceErrorContainer>
  )
}

export default BadDeviceDataError
